import _ from 'lodash'
import {ADD_SCHEDULED_CLASS, ADD_SCHEDULED_CLASSES, UPDATE_SCHEDULED_CLASS} from 'store/reducers/schedulingReducer'
const initState = {
    dashboard: {},
    instructor: {},
    reviews: [],
    reservations: [],
    clientInfo: {
        totalStudents: "loading",
        marketplaceStudents: "loading"
    },
    classes: [],
    offerings: [],
    categories: [],
    products: [],
    coupons: [],
    forms: []
}
export const CLASS_DELETED = "CLASS_DELETED"

export const SET_INSTRUCTOR_OFFERINGS = "SET_INSTRUCTOR_OFFERINGS"
export const ADD_INSTRUCTOR_OFFERING = "ADD_INSTRUCTOR_OFFERING"
export const UPDATE_INSTRUCTOR_OFFERING = "UPDATE_INSTRUCTOR_OFFERING"
export const DELETE_INSTRUCTOR_OFFERING = "DELETE_INSTRUCTOR_OFFERING"

export const SET_INSTRUCTOR_FORMS = "SET_INSTRUCTOR_FORMS"
export const ADD_INSTRUCTOR_FORM = "ADD_INSTRUCTOR_FORM"
export const UPDATE_INSTRUCTOR_FORM = "UPDATE_INSTRUCTOR_FORM"
export const DELETE_INSTRUCTOR_FORM = "DELETE_INSTRUCTOR_FORM"

export const SET_INSTRUCTOR_COUPONS = "SET_INSTRUCTOR_COUPONS"
export const ADD_INSTRUCTOR_COUPON = "ADD_INSTRUCTOR_COUPON"
export const UPDATE_INSTRUCTOR_COUPON = "UPDATE_INSTRUCTOR_COUPON"
export const DELETE_INSTRUCTOR_COUPON = "DELETE_INSTRUCTOR_COUPON"

export const SET_INSTRUCTOR_PRODUCTS = "SET_INSTRUCTOR_PRODUCTS"
export const ADD_INSTRUCTOR_PRODUCT = "ADD_INSTRUCTOR_PRODUCT"
export const UPDATE_INSTRUCTOR_PRODUCT = "UPDATE_INSTRUCTOR_PRODUCT"
export const DELETE_INSTRUCTOR_PRODUCT = "DELETE_INSTRUCTOR_PRODUCT"
export const ADD_INSTRUCTOR_RESERVATION = "ADD_INSTRUCTOR_RESERVATION"

export const ADD_INSTRUCTOR_CLASSES = "ADD_INSTRUCTOR_CLASSES"

export const ADD_INSTRUCTOR_RESERVATIONS = "ADD_INSTRUCTOR_RESERVATIONS"

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}
const instructorReducer = (state = initState, action) => {
    // console.log(`SENDING ACTION: ${action.type}`)
    switch (action.type) {
        case CLASS_DELETED:
            const classesAfterDelete = _.filter(state.classes, function(x) { return x?.platformID !== action?.classId; });
            return {
                ...state,
                classes: classesAfterDelete
            }
        case ADD_SCHEDULED_CLASS:
            var {classes} = state
            return {
                ...state,
                classes: classes.concat(action.class)
            }
        case ADD_SCHEDULED_CLASSES:
            var {classes} = state
            return {
                ...state,
                classes: classes.concat(action.classes)
            }
        case UPDATE_SCHEDULED_CLASS:
            return {
                ...state,
                classes: state.classes.map(item => {
                    if (item.id === action.class.platformID) {
                        return action.class
                    }
                    return item
                })
            }
        case SET_INSTRUCTOR_OFFERINGS:
            return {
                ...state,
                offerings: action.offerings
            }
        case ADD_INSTRUCTOR_OFFERING:
            var {offerings} = state
            return {
                ...state,
                offerings: offerings.concat(action.offering)
            }
        case UPDATE_INSTRUCTOR_OFFERING:
            return {
                ...state,
                offerings: state.offerings.map(item => {
                    if (item.id === action.offering.id) {
                        return action.offering
                    }
                    return item
                })
            }
        case DELETE_INSTRUCTOR_OFFERING:
            const offeringsAfterDelete = _.filter(state.offerings, function(x) { return x?.id !== action?.offering?.id; });
            return {
                ...state,
                offerings: offeringsAfterDelete
            }
        ///////////
        case SET_INSTRUCTOR_COUPONS:
            return {
                ...state,
                coupons: action.coupons
            }
        case ADD_INSTRUCTOR_COUPON:
            var {coupons} = state
            return {
                ...state,
                coupons: coupons.concat(action.coupon)
            }
        case UPDATE_INSTRUCTOR_COUPON:
            return {
                ...state,
                coupons: state.coupons.map(item => {
                    if (item.id === action.coupon.id) {
                        return action.coupon
                    }
                    return item
                })
            }
        case DELETE_INSTRUCTOR_COUPON:
            const couponsAfterDelete = _.filter(state.coupons, function(x) { return x?.id !== action?.coupon?.id; });
            return {
                ...state,
                coupons: couponsAfterDelete
            }
        ////
        case SET_INSTRUCTOR_FORMS:
            return {
                ...state,
                forms: action.forms
            }
        case ADD_INSTRUCTOR_FORM:
            var {forms} = state
            return {
                ...state,
                forms: forms.concat(action.form)
            }
        case UPDATE_INSTRUCTOR_FORM:
            return {
                ...state,
                forms: state.forms.map(item => {
                    if (item.id === action.form.id) {
                        return action.form
                    }
                    return item
                })
            }
        case DELETE_INSTRUCTOR_FORM:
            const formsAfterDelete = _.filter(state.forms, function(x) { return x?.id !== action?.form?.id; });
            return {
                ...state,
                forms: formsAfterDelete
            }
//         SET_INSTRUCTOR_FORMS
// ADD_INSTRUCTOR_FORM
// UPDATE_INSTRUCTOR_FORM
// DELETE_INSTRUCTOR_FORM
        case SET_INSTRUCTOR_PRODUCTS:
            let uniqueCategories = []
            const mapForFun = action.products.reduce((map, val) => {
                (val?.categories ?? []).forEach(cat => {
                    if (!map[cat]) {
                        map[cat] = true
                        uniqueCategories.push(cat)
                    }
                })
                return map
            }, {})

            return {
                ...state,
                categories: uniqueCategories.sort(),
                products: action.products
            }
        case ADD_INSTRUCTOR_PRODUCT:
            var {products} = state
            return {
                ...state,
                products: products.concat(action.product)
            }
        case UPDATE_INSTRUCTOR_PRODUCT:
            return {
                ...state,
                products: state.products.map(item => {
                    if (item.id === action.product.id) {
                        return {...action.product}
                    }
                    return item
                })
            }
        case DELETE_INSTRUCTOR_PRODUCT:
            const productsAfterDelete = _.filter(state.products, function(x) { return x?.id !== action?.product?.id; });
            return {
                ...state,
                products: productsAfterDelete
            }
        case 'SET_INSTRUCTOR':
            // console.log("fetching studios")
            state.instructor = action.instructor;
            return {
                ...state,
                instructor: {
                    ...action.instructor
                }
            }
            return state;
        case "SET_INSTRUCTOR_DASHBOARD_REVENUE":
            return {
                ...state,
                dashboard: {
                    ...state.dashboard,
                    lastThirtyRevenue: action.revenue
                }
            }
        case "SET_INSTRUCTOR_DASHBOARD":
            // state.dashboard = action.dashboard;
            // return state;
            return {
                ...state,
                dashboard: {
                    ...action.dashboard,
                    lastThirtyRevenue: state?.dashboard?.lastThirtyRevenue ?? 0
                }
            }
        case "ADD_INSTRUCTOR_CLASSES":
            return {
                ...state,
                classes: _.unionBy(state.classes, action.classes, 'platformID')
            }
        case ADD_INSTRUCTOR_RESERVATION:
            return {
                ...state,
                reservations: [
                    ...state.reservations,
                    action.reservation
                ]
            }
        case ADD_INSTRUCTOR_RESERVATIONS:
            console.log("ACTION RES: ", action.reservations)
            return {
                ...state,
                reservations: _.unionBy(action.reservations, state.reservations, 'platformID')
            }
        case "SET_INSTRUCTOR_REVIEWS":
            state.reviews = action.reviews;
            return state
    }

    return state
}

export default instructorReducer;